import { CompanyInfoResponse } from './openapi-admin-extended.model';

export type CmsContentType = 'SERVICE' | 'PAGE' | 'FAQ' | 'SOCIAL_LINK' | 'PARTNER' | 'TESTIMONIAL' | 'ANNOUNCEMENT' | 'MAINTENANCE';
export type CmsTarget = 'ALL' | 'AGRISOL' | 'KULAKWETU';

export interface CmsContent {
  id: string;
  type: CmsContentType;
  target: CmsTarget;
  slug: string;
  title: string;
  subtitle?: string | null;
  content?: string | null;
  imageUrl?: string | null;
  icon?: string | null;
  linkUrl?: string | null;
  linkLabel?: string | null;
  authorName?: string | null;
  authorRole?: string | null;
  displayOrder: number;
  published: boolean;
  featured: boolean;
  startsAt?: string | null;
  endsAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface PublicSlide {
  id: string;
  target: 'WEB' | 'MOBILE';
  imageUrl?: string | null;
  heading?: string | null;
  text?: string | null;
  description?: string | null;
  slug?: string | null;
  isPublic: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const DEFAULT_PUBLIC_COMPANY: CompanyInfoResponse = {
  id: 'fallback',
  legalName: 'AGRISOL',
  tradeName: 'AGRISOL',
  supportEmail: '',
  supportPhone: '',
  websiteUrl: '',
  addressLine: '',
  city: '',
  country: '',
  businessHours: '',
  logoUrl: '',
  faviconUrl: '',
  agrisolLogoUrl: '',
  agrisolFaviconUrl: '',
  agrisolAuthImageUrl: '',
  kulakwetuLogoUrl: '',
  kulakwetuFaviconUrl: '',
  kulakwetuAuthImageUrl: '',
  agrisolDescription: 'La plateforme numérique qui rapproche les acteurs de l’agriculture locale.',
  agricashDescription: '',
};

export const DEFAULT_PUBLIC_SLIDE: PublicSlide = {
  id: 'fallback',
  target: 'WEB',
  imageUrl: null,
  heading: 'Connecter l’agriculture locale au digital',
  text: 'Une expérience moderne pour découvrir les produits agricoles, commander et suivre leur livraison.',
  description: 'Une expérience moderne pour découvrir les produits agricoles, commander et suivre leur livraison.',
  slug: 'agriculture-locale',
  isPublic: true,
};
